/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */



import Store from "./store";
import par from "par";

import * as Sentry from "@sentry/react";

export default UserTokenStore;

function UserTokenStore(api) {
	var store = new Store();

	store._get = store.get;
	store.get = get;

	var tracking = [];

	return store;

	function get(id) {
		if (!id) return "undefined";
		var existing = store._get(id);
		if (existing) return existing;

		if (!isTracking(id))
			track(id);

		return " ... ";
	}

	function isTracking(id) {
		return tracking.indexOf(id) !== -1;
	}

	function track(id) {
		tracking.push(id);
		api.org.users.token(id)
			.then(par(setToken, id))
			.catch(error => {
				Sentry.captureException(error);
				console.error.bind(console, error);
			});
	}

	function setToken(id, data) {
		var token = data.token;
		store.set(id, token);
	}
}
